import { FC } from "react";
import { Market } from "@/lib/wsTypes";
import { formatAssetLabel } from "@/lib/marketUtils";
import { TOKEN_LORE } from "@/lib/lore";

/**
 * The selected market's cast card — the participant-safe slice of the season
 * bible (who this company is and what it walked into on day 1). Pure static
 * lore: nothing here derives from the event schedule.
 */
export const TokenLoreCard: FC<{ selectedMarket: Market | null }> = ({ selectedMarket }) => {
  const base = selectedMarket ? formatAssetLabel(selectedMarket.tradingPair.base) : null;
  const lore = base ? TOKEN_LORE[base] : null;

  if (!lore) {
    return (
      <section className="sr-panel flex h-full flex-col px-4 py-4" aria-label="Token info">
        <span className="text-xs font-medium uppercase tracking-wide text-sr-neutral-500">
          Token info
        </span>
        <p className="mt-3 text-sm text-sr-neutral-400">Pick a market to meet the company.</p>
      </section>
    );
  }

  const quoteLore = TOKEN_LORE.VAN;
  return (
    <section className="sr-panel flex h-full flex-col overflow-y-auto px-4 py-4" aria-label="Token info">
      <span className="text-xs font-medium uppercase tracking-wide text-sr-neutral-500">
        Token info
      </span>
      <div className="mt-2 flex items-baseline gap-2">
        <h3 className="text-base font-semibold text-white">{lore.company}</h3>
        {lore.epithet && (
          <span className="text-xs italic text-sr-neutral-400">“{lore.epithet}”</span>
        )}
      </div>
      <p className="mt-0.5 text-xs font-medium text-sr-lemon-muted">{lore.motto}</p>
      <p className="mt-3 text-sm leading-relaxed text-sr-neutral-200">{lore.character}</p>
      <p className="mt-3 text-sm leading-relaxed text-sr-neutral-400">
        <span className="font-medium text-sr-neutral-300">Walking into day 1: </span>
        {lore.day1}
      </p>
      <p className="mt-auto pt-3 text-xs text-sr-neutral-500">
        Quoted in {quoteLore.token} — {quoteLore.company}: {quoteLore.motto}
      </p>
    </section>
  );
};
